import PropTypes from 'prop-types'

import BorderOutlinedIcon from '@ant-design/icons/BorderOutlined'
import CheckSquareFilledIcon from '@ant-design/icons/CheckSquareFilled'

import Button from '@mui/material/Button'
import { styled } from '@mui/material/styles'

import { getTestId } from '@shared/utils'

ToggleFilter.propTypes = {
  /** Label of the button */
  label: PropTypes.string.isRequired,

  /** If `true`, the filter is applied */
  value: PropTypes.bool,

  /** Callback fired when the value changes */
  onChange: PropTypes.func,

  /** Disable the filter */
  disabled: PropTypes.bool,
}

/**
 * Button that toggles a single filter on and off.
 *
 * When off the filter is not applied at all, so the list is not narrowed down.
 *
 * @example
 * <ToggleFilter label="CPA" value={value} onChange={handleChange} />
 */
export default function ToggleFilter({ label, value = false, onChange, disabled = false, ...other }) {
  const testId = getTestId(other, `toggle-filter-${label}`)

  return (
    <Button
      color={value ? 'primary' : 'inherit'}
      variant={value ? 'contained' : 'text'}
      endIcon={value ? <CheckSquareFilledIcon /> : <UncheckedIcon />}
      disabled={disabled}
      sx={{ '& .MuiButton-endIcon > *:nth-of-type(1)': { fontSize: 13 } }}
      onClick={() => onChange(!value)}
      data-testid={`${testId}-button`}
      data-test-checked={value}
      {...other}
    >
      {label}
    </Button>
  )
}

const UncheckedIcon = styled(BorderOutlinedIcon)(({ theme }) => ({
  color: theme.palette.text.secondary,
}))
